export enum ValidationError {
  REQUIRED = "This field is required",
  EMAIL = "This field must be an email",
  NUMBER = "This field must be a number",
  PLAIN = "This field must be plain",
  PLAIN_SPACE = "This field must be plain",
}
